export const inputCls =
  "w-full bg-[var(--o-bg)] border border-[var(--o-border)] px-3 py-2.5 text-sm text-[var(--o-fg)] outline-none focus:border-[var(--o-fg)] transition-colors placeholder:text-[var(--o-muted3)]";

export const labelCls = "font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--o-muted2)]";

export const btnPrimary =
  "inline-flex items-center justify-center gap-2 bg-[var(--o-fg)] text-[var(--o-bg)] font-semibold px-5 py-2.5 text-sm hover:opacity-90 active:translate-y-[1px] disabled:opacity-40 disabled:cursor-not-allowed transition-[opacity,transform,background-color]";

export const btnGhost =
  "inline-flex items-center justify-center gap-2 border border-[var(--o-border)] text-[var(--o-fg)] px-4 py-2 text-sm hover:bg-[var(--o-surface)] hover:border-[var(--o-border-strong)] disabled:opacity-40 disabled:cursor-not-allowed transition-colors";
